import CONSTANTS from "../CONSTANTS";

export const actionGetOrder = (orderId) => ({
  type: CONSTANTS.PRACTICE_ORDER_GET,
  orderId,
});

export const actionGetOrdersList = (page = 0, limit = 5 , search=null) => ({
  type: CONSTANTS.PRACTICE_ORDER_GET_LIST,
  page,
  limit,
  search
});

export const actionSetOrdersList = (orders) => ({
  type: CONSTANTS.PRACTICE_ORDER_SET_LIST,
  orders,
});

export const actionSetEditOrder = (order) => ({
  type: CONSTANTS.PRACTICE_ORDER_SET_EDIT,
  order
});

export const actionOrderSubmitEdition = (data) => ({
  type: CONSTANTS.PRACTICE_ORDER_SUBMIT_EDIT,
  data
})

export const actionOrderSubmitForm = (data) => ({
  type: CONSTANTS.PRACTICE_ORDER_SUBMIT_FORM,
  data
});

export const actionGetReservedKits = (orderId) => ({
  type: CONSTANTS.PRACTICE_ORDER_GET_RESERVED_KITS,
  orderId
});

export const actionSetReservedKits = (kits) => ({
  type: CONSTANTS.PRACTICE_ORDER_SET_RESERVED_KITS,
  kits
});

export const actionDeleteKitFromOrder = (orderId, kitId, kitType) => ({
  type: CONSTANTS.PRACTICE_ORDER_DELETE_KIT,
  orderId,
  kitId,
  kitType
});

export const actionDeleteOrder = (orderId) => ({
  type: CONSTANTS.PRACTICE_ORDER_CANCEL,
  orderId
});

export const actionSetKitDeleteLoading = (value) => ({
  type: CONSTANTS.PRACTICE_ORDER_SET_KIT_DELETE_LOADING,
  value
});

export const actionAutoAssignKits = (orderId) => ({
  type: CONSTANTS.PRACTICE_ORDER_AUTO_ASSIGN_KITS,
  orderId
});

export const actionGetOrderStateMachine = () => ({
  type: CONSTANTS.PRACTICE_ORDER_GET_STATE_MACHINE,
});

export const actionSetOrderStateMachine = (machine) => ({
  type: CONSTANTS.PRACTICE_ORDER_SET_STATE_MACHINE,
  machine
});